var module = angular.module('octopusApp.users');

module.controller('ProfileController', function($scope, $window, $location, octoDialog, busy, octopusRepository, octopusPermissionSet, unsavedChanges) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    $scope.tab = "profile";
    $scope.changeTab = function (v) { $scope.tab = v; };

    isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function(status) {
        isLoading.promise(octopusRepository.Users.getCurrent().then(function(me) {
            $scope.user = me;
            $scope.status = status;
            $scope.view = { showPasswordChange: false, confirmNewPassword: '' };

            return octopusPermissionSet.isAuthorized({ permission: 'EventView', projectId: '*', environmentId: '*' }).then(function(yn) {
                if (yn) {
                    return octopusRepository.Events.list({ user: me.Id }).then(function(events) {
                        $scope.activity = events;
                    });
                }
            });
        }));
    }));

    $scope.save = function() {
        if ($scope.user.IsActive && $scope.view.showPasswordChange) {
            if ($scope.user.Password !== $scope.view.confirmNewPassword) {
                isSaving.showError('The passwords do not match');
                return;
            }
        } else {
            $scope.user.Password = null;
        }
        isSaving.promise(octopusRepository.Users.save($scope.user).then(function() {
            unsavedChanges.saved();
            $window.location.reload();
        }));
    };
});









//////////////////
// WEBPACK FOOTER
// ./app/areas/users/controllers/profile_controller.js
// module id = 7532386652177036
// module chunks = 1